import {IBlackListRule, IBooleanRule, IRangeIntRule, IWhiteListRule} from "./SegmentationRules";
import {AbstractValidatable, ValidationErrorsObject} from "frontend-core";
import {ProductCode, ProductCodeEnum} from "@/modules/Segmentation/models/ProductCode";

export class AntiSegmentRule extends AbstractValidatable {
    public title: string = "";
    public transportType: IWhiteListRule = {whiteList: [], isException: false};
    public clientType: IWhiteListRule = {whiteList: [], isException: false};
    public isMultiDrive: IBooleanRule = {boolean: null};
    public purposeType: IWhiteListRule = {whiteList: [], isException: false};
    public carModelException: IBlackListRule = {blackList: [], isException: false};
    public age: IRangeIntRule = {from: null, to: null};
    public power: IRangeIntRule = {from: null, to: null};
    public kbm: IRangeIntRule = {from: null, to: null};
    public coefficientTerritory: IRangeIntRule = {from: null, to: null};
    public periodUse: IRangeIntRule = {from: null, to: null};
    public periodDays: IRangeIntRule = {from: null, to: null};
    public usagePeriods: IRangeIntRule = {from: null, to: null};
    public yearManufacture: IRangeIntRule = {from: null, to: null};
    public driverExperience: IRangeIntRule = {from: null, to: null};
    public ownerLastNameException: IBlackListRule = {blackList: [], isException: false};
    public insurerLastNameException: IBlackListRule = {blackList: [], isException: false};
    public nameException: IBlackListRule = {blackList: [], isException: false};
    public middlenameException: IBlackListRule = {blackList: [], isException: false};
    public okved: IBlackListRule = {blackList: [], isException: false};
    public permittedMass: IRangeIntRule = {from: null, to: null};
    public clientAddressCode: IWhiteListRule = {whiteList: [], isException: false};
    public productCode: IWhiteListRule<ProductCode> = {whiteList: [], isException: false};
    public partnerId: IWhiteListRule = {whiteList: [], isException: false};
    public isActive: IBooleanRule = {boolean: true};
    public isMasterRule: IBooleanRule = {boolean: false};
    public isNotExistVin: IBooleanRule = {boolean: null};
    public isForbidRule: IBooleanRule = {boolean: false};
    public orgInn: IWhiteListRule = {whiteList: [], isException: false};
    public isUseSupplementary: IBooleanRule = {boolean: null};

    public errors: ValidationErrorsObject<{
        title: string[],
        age: string[],
        power: string[],
        kbm: string[],
        coefficientTerritory: string[],
        periodUse: string[],
        periodDays: string[],
        usagePeriods: string[],
        yearManufacture: string[],
        driverExperience: string[],
        permittedMass: string[],
    }> = {
        title: [],
        age: [],
        power: [],
        kbm: [],
        coefficientTerritory: [],
        periodUse: [],
        periodDays: [],
        usagePeriods: [],
        yearManufacture: [],
        driverExperience: [],
        permittedMass: [],
    };

    constructor(dto?: IAntiSegmentDto) {
        super();

        if (dto) {
            Object.assign(this, dto);
            this.isNotExistVin = dto.isNotExistVin;
        }

        this.transportType.whiteList = dto?.transportType.whiteList || [];
        this.clientType.whiteList = dto?.clientType.whiteList || [];
        this.carModelException.blackList = dto?.carModelException.blackList || [];
        this.ownerLastNameException.blackList = dto?.ownerLastNameException.blackList || [];
        this.insurerLastNameException.blackList = dto?.insurerLastNameException?.blackList || [];
        this.nameException.blackList = dto?.nameException.blackList || [];
        this.middlenameException.blackList = dto?.middlenameException.blackList || [];
        this.okved.blackList = dto?.okved?.blackList || [];
        this.clientAddressCode.whiteList = dto?.clientAddressCode.whiteList || [];
        this.productCode.whiteList = dto?.productCode.whiteList?.map(i => new ProductCode(i)) || [
            new ProductCode(ProductCodeEnum.osago, "osago"),
        ];
        this.partnerId.whiteList = dto?.partnerId.whiteList || [];
        this.purposeType.whiteList = dto?.purposeType.whiteList || [];
        this.orgInn.whiteList = dto?.orgInn.whiteList || [];
    }
}

export interface IAntiSegmentDto {
    title: string;
    transportType: IWhiteListRule;
    clientType: IWhiteListRule;
    isMultiDrive: IBooleanRule;
    purposeType: IWhiteListRule;
    carModelException: IBlackListRule;
    age: IRangeIntRule;
    power: IRangeIntRule;
    kbm: IRangeIntRule;
    coefficientTerritory: IRangeIntRule;
    periodUse: IRangeIntRule;
    periodDays: IRangeIntRule;
    usagePeriods: IRangeIntRule;
    yearManufacture: IRangeIntRule;
    driverExperience: IRangeIntRule;
    insurerLastNameException: IBlackListRule;
    ownerLastNameException: IBlackListRule;
    nameException: IBlackListRule;
    middlenameException: IBlackListRule;
    okved: IBlackListRule;
    permittedMass: IRangeIntRule;
    clientAddressCode: IWhiteListRule;
    productCode: IWhiteListRule;
    partnerId: IWhiteListRule;
    isActive: IBooleanRule;
    orgInn: IWhiteListRule;
    isMasterRule: IBooleanRule;
    isNotExistVin: IBooleanRule;
    isForbidRule: IBooleanRule;
    isUseSupplementary: IBooleanRule;
}
